/**
 * 左侧菜单
 */
import {mapState} from 'vuex';
import * as R from 'ramda';
import {Pic} from '@/comp';
import {notice as noticeApi} from '@/api';
import {getPathList} from '@/utils/rbac';

export default {
  name: 'MenuNav',
  props: {
    datasource: {
      type: Array,
      required: true,
      default() {
        return [];
      },
    },
    defaultActive: {
      type: String,
    },
  },
  components: {Pic},
  data() {
    return {
      visible: true,
      interval: null,
      noticeData: {}
    };
  },
  computed: {
    ...mapState('common', ['userInfo']),
    computedDefaultActive() {
      if (this.$route.meta.navigateMatchFullPath === true) { // 导航active效果匹配path
        return this.$route.fullPath;
      }
      return this.$route.name;
    },
    menuWidth() {
      return this.visible ? '184px' : 'auto';
    },
  },
  created() {
    this.interval = setInterval(() => {
      this.loadNotice();
    }, 1000 * 60);
  },
  methods: {
    iconFilters(e) {
      const pathList = getPathList([e]);
      if (R.any(R.propEq('path', this.$route.name))(pathList)) {
        return e.activeIcon || e.icon;
      }
      return e.icon;
    },
    menuClass(e) {
      const pathList = getPathList([e]);
      return {
        selected: R.any(R.propEq('path', this.$route.name))(pathList),
      };
    },
    onChangeVisible(val) {
      this.visible = val;
    },
    onchangeRoute(routerName) {
      this.$router.push({
        name: routerName,
      })
        .catch(() => {
        });
    },
    async loadNotice() {
      const path = this.$route.path;
      if (path.indexOf('login') > -1 || path.indexOf('findPass') > -1 || path.indexOf('register') > -1) {
        clearInterval(this.interval);
        return;
      }
      const data = await noticeApi.task();
      if (data.code === 10000) {
        this.noticeData = (data.data);
      }
    },
    showBadge(item) {
      const noticeData = JSON.parse(JSON.stringify(this.noticeData));
      // 当通知消息数量被渲染完 重新请求
      // if (!noticeData || Object.keys(noticeData).length <= 0) {
      //   this.loadNotice();
      // }
      // 通知消息 有数据后
      if (noticeData && Object.keys(noticeData).length > 0) {
        // 全部订单 不显示
        if (item.path === 'OrderAll' || item.path === 'OrderAllInner') {
          return false;
        } else if (item.path === 'OrderUnsubmit' || item.path === 'OrderUnsubmitInner') {
          // 数据待提交
          return this.showByItem('11');
        } else if (item.path === 'OrderSubmited' || item.path === 'OrderSubmitedInner') {
          // 数据待提交
          return this.showByItem('12');
        } else if (item.path === 'OrderProcessing' || item.path === 'OrderProcessingInner') {
          // 数据待提交
          return this.showByItem('13');
        } else if (item.path === 'OrderFinished' || item.path === 'OrderFinishedInner') {
          // 数据待提交
          return this.showByItem('14');
        }
      }
    },
    showByItem(item) {
      const noticeData = JSON.parse(JSON.stringify(this.noticeData));
      const count = noticeData[item];
      // delete this.noticeData[item];
      // const index = this.noticeData.indexOf(item);
      // if (index > -1) {
      //   this.noticeData.splice(index, 1);
      // }
      return count && count > 0;
    }
  }
};



// WEBPACK FOOTER //
// ./src/comp/MenuNav/_.js